import { FC, memo, useEffect, useState } from 'react';
import { LangType } from 'store/lang/lang.slice';
import { translate } from 'localizations';
import { CallTranslatedText } from 'store/calls/calls.types';
import styles from './styles.module.scss';
import { SelectWithIcon } from 'shared/ui';

interface CallBodyCallTopTranslateProps {
	language: LangType | string;
	callId: string;
	title: string;
	languagesList: { value: string; label: string }[];
	langItem: { value: string; label: string } | null;
	callTranslated: CallTranslatedText[] | null;
	getTranslateHandle: (callIdForTranslate: string, languageValue: { value: string; label: string }) => void;
}

const CallBodyCallTopTranslate: FC<CallBodyCallTopTranslateProps> = ({
	language,
	callId,
	title,
	languagesList,
	langItem,
	callTranslated,
	getTranslateHandle,
}) => {
	const languagesOptions = [{ value: 'original', label: `${translate('original', language)}` }, ...languagesList];

	const [selectedLang, setSelectedLang] = useState<string>('');

	useEffect(() => {
		if (langItem === null || langItem.value === 'original') {
			setSelectedLang(translate('translate', language));
		} else {
			setSelectedLang(langItem.label);
		}
	}, [langItem, language]);

	return (
		<div className={styles.topFlex}>
			<div className={styles.topTitle}>
				<div>{title}</div>
				{callTranslated && <div className={styles.topTitleRight}>{translate('translatedCall', language)}</div>}
			</div>
			<SelectWithIcon
				buttonText={selectedLang}
				options={languagesOptions}
				onOptionSelect={(option) => getTranslateHandle(callId, option)}
				className={styles.topTranslateButton}
			/>
		</div>
	);
};

export default memo(CallBodyCallTopTranslate);
